export default __webpack_public_path__ + "static/media/icon-coin-elf.69d9477c.svg";